import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import PrayerUnits from './components/PrayerUnits';
import GideonFeatured from './components/GideonFeatured';
import AppFeatures from './components/AppFeatures';
import Features from './components/Features';
import HowToInstall from './components/HowToInstall';
import BetaDisclaimer from './components/BetaDisclaimer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PreRegistration from './components/PreRegistration';
import Registration from './components/auth/Registration';
import Login from './components/auth/Login';
import SuccessPage from './components/auth/SuccessPage';
import Dashboard from './pages/Dashboard';
import GideonForcePage from './pages/GideonForcePage';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="min-h-screen">
            <Routes>
              {/* Authentication Routes */}
              <Route path="/auth/register" element={<Registration />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/success" element={<SuccessPage />} />
              
              {/* Protected Routes */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              
              {/* Public Pages */}
              <Route path="/gideon-force" element={
                <>
                  <Header isScrolled={isScrolled} />
                  <main>
                    <GideonForcePage />
                  </main>
                  <Footer />
                </>
              } />
              
              {/* Main Website Routes */}
              <Route path="/*" element={
                <>
                  <Header isScrolled={isScrolled} />
                  <main>
                    <Hero />
                    <About />
                    <PrayerUnits />
                    <GideonFeatured />
                    <AppFeatures />
                    <Features />
                    <PreRegistration />
                    <HowToInstall />
                    <BetaDisclaimer />
                    <PrivacyPolicy />
                    <TermsOfService />
                    <FAQ />
                    <Contact />
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App; 